export default "__VITE_ASSET__BGLWPcUN__"